import React, { useEffect, useMemo, useState } from "react";
import * as S from "./Profile.style";

// Components
import ProfileForm from "./components/profileForm";
import InvitationsManagement from "../patients/components/invitationsManagement";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Billing from "./components/billing";
import { QUERY_GET_PROCESS_TYPES } from "../../../graphql/queries/Process";
import { useQuery } from "@apollo/client";

const ENV = process.env.REACT_APP_ENV;

function Profile() {
  const { t, i18n: { language } } = useTranslation("global");
  const location = useLocation();  
  const { data: processTypes } = useQuery(QUERY_GET_PROCESS_TYPES);

  const [tabs, setTabs] = useState([
    {
      id: 1,
      title: t("profile.myAccount"),
      icon: "zaia-i-person"
    },
    {
      id: 2,
      title: t("profile.patientsManagement"),
      icon: "zaia-i-patient-mangement"
    }
  ])

  const callCondition = useMemo(() => {
    return ENV === "development" || 
      (
        ENV === "production" && 
        (
          processTypes?.process.find(process => process.id === 73) ||
          processTypes?.process.find(process => process.id === 50) 
        )
      )
  }, [processTypes])  

  useEffect(() => {
    if(callCondition) {
      if(tabs.find(tab => tab.id === 3)) return;
      setTabs(prevTabs => [
        ...prevTabs,
        {
          id: 3,
          title: t("globally.billing"),
          icon: "zaia-i-general-view"
        }
      ]);
    }
  }, [processTypes]);


  const [tabSelected, setTabSelected] = useState(tabs[0])

  useEffect(() => {
    const searchLocation = location.search;
    const params = new URLSearchParams(searchLocation);
    if(Boolean(params.get("management")) === true) {
      setTabSelected(tabs[1])
    }
  }, [])

  return (
    <S.ProfileDiv>
      <div className="profile-tabs">
        {
          tabs.map((tab) =>
            {
              return (
                <div
                  className={`profile-tab ${tab.id === tabSelected.id && "profile-tab--active"}`}
                  key={tab.id}
                  onClick={() => setTabSelected(tab)}
                >
                  <i className={`profile-tab__icon icon ${tab.icon}`}></i>
                  <div className="profile-tab__text">
                    {tab.title}
                  </div>
                </div>
              )
            }
          ) 
        }
      </div>
      <div className="profile-content">
        {
          tabSelected.id === 1 &&
            <ProfileForm />
        }
        {
          tabSelected.id === 2 &&
            <InvitationsManagement/>
        }
        {
          tabSelected.id === 3 &&
            <Billing />
        }

      </div>
      {/* <div className="profile__right-side">
        <MedicalInstitutions />
      </div> */}
    </S.ProfileDiv>
  );
}

export default Profile;
